<script>
  import { cssPrefix } from '../helper-classes.js'

  export let position = 'start'

  const classes = []
  if (!['start', 'end'].includes(position)) {
    console.debug(`[DS:NavbarZone] invalid position ${position}`)
  } else if (position) {
    classes.push(`${cssPrefix}navbar-` + position)
  }
</script>

<nav class={classes.join(' ')}>
  <ul class={`${cssPrefix}navbar-list`}>
    <slot />
  </ul>
</nav>
